import React, { useState } from "react";

import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";

const GeneralStats = ({ data }) => {
  const theme = useTheme();
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 5,
      }}
    >
      <Stack gap={2}>
        <Typography onClick={() => setShowDetails(!showDetails)} variant="h5">
          Statistiche generali
        </Typography>
        {showDetails ? (
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero volontari:
              <b>{data.admins_members_volunteer.n_vol ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero amministratori:
              <b>{data.admins_members_volunteer.n_admins ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero soci:
              <b>{data.admins_members_volunteer.n_members ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Followers:
              <b>{data.n_followers ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Eventi totali: <b>{data.total_events ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Eventi medi settimanali: <b>{data.average_weekly_events ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Eventi medi mensili: <b>{data.average_monthly_events ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero medio turni per evento:
              <b>{data.average_number_shifts ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero di notifiche inviate:
              <b>{data.number_notifications_sent ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero di richieste per diventare volontari:
              <b>{data.number_requests_volunteer ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero di richieste di iscrizione turno:
              <b>{data.number_requests_shift ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero medio di richieste per turno:
              <b>{data.average_requests_for_shift ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Numero di domande:
              <b>{data.number_questions ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Click sulle associazioni:
              <b>{data.number_clicks_association ?? 0}</b>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              Click sugli eventi:
              <b>{data.number_clicks_event ?? 0}</b>
            </Grid>
          </Grid>
        ) : null}

        <Typography
          onClick={() => setShowDetails(!showDetails)}
          variant="body"
          sx={{
            textDecoration: "underline",
            alignSelf: "flex-end",
            cursor: "pointer",
          }}
        >
          {showDetails ? "Nascondi" : "Vedi dettagli"}
        </Typography>
      </Stack>
    </Box>
  );
};

export default GeneralStats;
